import React from 'react';
import { useTranslation } from 'react-i18next';
import { MessageSquare, Target, BarChart, ArrowRight } from 'lucide-react';

export default function LandingHowItWorks() {
  const { t } = useTranslation();
  const steps = [
    { step: '01', title: t('landing.howItWorks.step1.title'), description: t('landing.howItWorks.step1.description'), icon: MessageSquare },
    { step: '02', title: t('landing.howItWorks.step2.title'), description: t('landing.howItWorks.step2.description'), icon: Target },
    { step: '03', title: t('landing.howItWorks.step3.title'), description: t('landing.howItWorks.step3.description'), icon: BarChart },
  ];
  return (
    <section id="how-it-works" className="py-24 bg-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-foreground mb-4">
            {t('landing.howItWorks.title')}
          </h2>
          <p className="text-lg max-w-3xl mx-auto text-brand-ink">
            {t('landing.howItWorks.subtitle')}
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((item) => (
            <div key={item.step} className="relative group">
              <div className="bg-white p-8 shadow-lg h-full rounded-lg border border-border">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl mb-6 group-hover:scale-110 transition-transform bg-primary text-primary-foreground">
                  <item.icon className="w-8 h-8" />
                </div>
                <div className="text-sm font-bold mb-2 text-muted-foreground">
                  {t('landing.howItWorks.step1.label').replace('01', item.step)}
                </div>
                <h3 className="text-2xl font-bold mb-4 text-foreground">
                  {item.title}
                </h3>
                <p className="leading-relaxed text-brand-ink">
                  {item.description}
                </p>
              </div>
              {item.step !== '03' && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <ArrowRight className="w-8 h-8 text-border" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
